import { VenereBox, VenereButton } from "../ui"
import VenereScan from "../ui/icons/VenereScan"

const VenereBodyScanBox = () => {
    return (
        <VenereBox variant="lavender" className="w-full max-w-[800px]">
            <div className="bg-white rounded-lg p-4 self-center w-full flex flex-col items-center gap-4">
                <div className="venere-text-primary text-center">
                    Body scan time
                </div>
                <div className="venere-text-secondary text-center">
                    Ottieni un'analisi corporea aggiornata in pochi secondi.
                </div>
                <VenereScan className="w-20 h-20 text-venere-royal" />
                <VenereButton onClick={() => window.alert("Presto da te!")}>
                    Scannerizza subito
                </VenereButton>
            </div>
        </VenereBox>
    )
}

export default VenereBodyScanBox
